import { BlockInterface } from '@/components/pageContent/typings/block.interface';
import { IProfileInPageContent } from '@/pages/page/typings/page-content.interface';
import { PagingInterface, ProfileListItemInterface } from '@/types';

export interface CollectionBlockInterface extends BlockInterface {
  title: string;
  subTitle?: string;
  collectionId: number;
  displayCount: number;
  appList: ProfileListItemInterface[];
  isLoading?: boolean;
  profiles: {
    records: IProfileInPageContent[];
    paging: PagingInterface;
  };
}

export enum CollectionBlockPropertyEnum {
  TITLE = 'title',
  SUB_TITLE = 'subTitle',
  COLLECTION_ID = 'collectionId',
  DISPLAY_COUNT = 'displayCount',
}

export enum DisplayOnAppsEnum {
  All = 9999,
}
